export const FEATURED_STORIES = Object.freeze([
  {
    legacySlug: "test-objava-1",
    title: "Salt on Skin",
    slug: "salt-on-skin",
    excerpt: "A coastal note on sharp light and complete freedom.",
    coverUrl: "/assets/lolaabsolut/editorial-rocks.webp",
    paragraphs: [
      "## Salt, light, freedom",
      "A coastal note on sharp light, salt water and the kind of freedom that needs no permission.",
      "The sea changes everything: the pace, the colour and the way a moment stays with you."
    ]
  },
  {
    legacySlug: "test-objava-2",
    title: "Heat Without Permission",
    slug: "heat-without-permission",
    excerpt: "Summer does not ask. Neither should you.",
    coverUrl: "/assets/lolaabsolut/editorial-pool.webp",
    paragraphs: [
      "## Heat without permission",
      "Summer does not ask. Neither should you. Step into the colour, take up the space and let the day become entirely yours.",
      "No filter, no instructions—just instinct, warm light and a point of view."
    ]
  },
  {
    legacySlug: "test-objava-3",
    title: "The Coastal Issue",
    slug: "the-coastal-issue",
    excerpt: "Fashion, sound and a horizon with no instructions.",
    coverUrl: "/assets/lolaabsolut/editorial-night-standing-square.webp",
    paragraphs: [
      "## The coastal issue",
      "Fashion, sound and a horizon with no instructions. A visual dispatch from the space between after-sun and after-dark.",
      "Every look is a mood, every track is a direction and every image leaves a mark."
    ]
  },
  {
    legacySlug: "majhni-koraki-vsak-dan",
    title: "After Sun",
    slug: "after-sun",
    excerpt: "The hour when every colour becomes more honest.",
    coverUrl: "/assets/lolaabsolut/editorial-night-seated-square.webp",
    paragraphs: [
      "## After sun",
      "The hour when every colour becomes more honest and the night begins to write its own story.",
      "Stay for the sound, the people and the version of yourself that appears after dark."
    ]
  }
]);
